export default "__VITE_ASSET__1300e545__"